(() => {
  const productInfo = document.querySelector("product-info[data-url='/products/miata-supercharger-standard-kit-1']");
  if (!productInfo) return;

  document.documentElement.classList.add('ffs-main-kit-page');

  const button = productInfo.querySelector('.product-form__submit');
  const leftRotor = button?.querySelector('.ffs-main-kit-rotor-left');
  const rightRotor = button?.querySelector('.ffs-main-kit-rotor-right');
  if (!button || !leftRotor || !rightRotor) return;

  const points = [];
  const samples = 128;
  for (let index = 0; index < samples; index += 1) {
    const theta = (index / samples) * Math.PI * 2 - Math.PI / 2;
    const radius = 8.4 + 2.1 * Math.cos(4 * theta);
    points.push(`${(Math.cos(theta) * radius).toFixed(3)} ${(Math.sin(theta) * radius).toFixed(3)}`);
  }
  const profile = `M${points.join('L')}Z`;
  button.querySelectorAll('.ffs-main-kit-rotor-face').forEach((face) => face.setAttribute('d', profile));

  const normalizeAutomaticLabel = () => {
    productInfo.querySelectorAll('.product-form__input label').forEach((label) => {
      label.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.nodeValue.includes('Autotomatic')) {
          node.nodeValue = node.nodeValue.replace('Autotomatic', 'Automatic');
        }
      });
    });
  };
  normalizeAutomaticLabel();

  const syncMobilePrice = () => {
    const sourcePrice = productInfo.querySelector('[id^="price-"]');
    const mobilePrice = productInfo.querySelector('[data-ffs-mobile-price]');
    if (sourcePrice && mobilePrice && mobilePrice.innerHTML !== sourcePrice.innerHTML) {
      mobilePrice.innerHTML = sourcePrice.innerHTML;
    }
  };
  syncMobilePrice();

  const updateCarbStatus = () => {
    const carbStatus = productInfo.querySelector('[data-ffs-carb-status]');
    if (!carbStatus) return;

    const selectedYear = (productInfo.querySelector('input[type="radio"][name^="Year-"]:checked')?.value || '')
      .trim()
      .replaceAll('–', '-');
    const title = carbStatus.querySelector('[data-ffs-carb-title]');
    const detail = carbStatus.querySelector('[data-ffs-carb-detail]');
    const californiaDetails = document.querySelector('[data-ffs-2004-2005-details]');
    const coveredYears = new Set([
      '1990-1993',
      '1994-1995',
      '1994-1997',
      '1996-1997',
      '1999-2000',
      '2001-2003',
    ]);
    const state = selectedYear === '2001-2005'
      ? 'split'
      : selectedYear === '2004-2005'
        ? 'not-covered'
        : coveredYears.has(selectedYear)
          ? 'covered'
          : 'neutral';
    const setText = (element, value) => {
      if (element && element.textContent !== value) element.textContent = value;
    };

    carbStatus.classList.remove(
      'ffs-main-kit-carb-selection--split',
      'ffs-main-kit-carb-selection--not-covered',
      'ffs-main-kit-carb-selection--neutral',
    );
    carbStatus.dataset.ffsCarbState = state;

    if (state === 'split') {
      carbStatus.classList.add('ffs-main-kit-carb-selection--split');
      setText(title, '2001–2003 is covered by CARB Executive Order D-617-2.');
      setText(detail, '2004–2005 is not covered by this Executive Order.');
    } else if (state === 'not-covered') {
      carbStatus.classList.add('ffs-main-kit-carb-selection--not-covered');
      setText(title, 'Not covered by CARB Executive Order D-617-2.');
      setText(detail, 'California public-road orders are not available for 2004–2005 applications.');
    } else if (state === 'covered') {
      setText(title, 'CARB Executive Order D-617-2 applies to this configuration.');
      setText(detail, 'Valid when supplied in the listed FFS configuration.');
    } else {
      carbStatus.classList.add('ffs-main-kit-carb-selection--neutral');
      setText(title, 'Select a model year to confirm CARB status.');
      setText(detail, 'Coverage is confirmed only for a recognized year selection.');
    }

    if (californiaDetails) {
      const showCaliforniaDetails = state === 'split' || state === 'not-covered';
      californiaDetails.hidden = !showCaliforniaDetails;
      californiaDetails.open = state === 'not-covered';
    }
  };

  updateCarbStatus();
  productInfo.addEventListener('change', (event) => {
    if (event.target.matches('input[type="radio"][name^="Year-"]')) updateCarbStatus();
  });

  new MutationObserver(() => {
    normalizeAutomaticLabel();
    updateCarbStatus();
    syncMobilePrice();
  }).observe(productInfo, {
    childList: true,
    subtree: true,
  });

  const excludedGalleryFiles = new Set([
    'v-TVs900-ffs-kit-01.jpg',
    'v-TVs900-ffs-kit-02.jpg',
    'v-TVs900-ffs-kit-03.jpg',
    'v-TVs900-ffs-kit-04.jpg',
    'v-TVs900-ffs-kit-05.jpg',
  ]);
  const isExcludedGalleryImage = (image) => {
    if (!image) return false;
    const source = image.currentSrc || image.src || '';
    return [...excludedGalleryFiles].some((fileName) => source.includes(`/${fileName}`));
  };

  productInfo.querySelectorAll('.product__media-list .product__media-item').forEach((item) => {
    if (isExcludedGalleryImage(item.querySelector('img'))) item.remove();
  });
  productInfo.querySelectorAll('.thumbnail-list__item').forEach((item) => {
    if (isExcludedGalleryImage(item.querySelector('img'))) item.remove();
  });

  const galleryViewer = productInfo.querySelector("slider-component[id^='GalleryViewer-']");
  const visibleMediaItems = [...productInfo.querySelectorAll('.product__media-list .product__media-item')];
  const thumbnailButtons = [...productInfo.querySelectorAll('.thumbnail-list button')];

  const galleryPreloadAhead = 2;
  const preloadUpcomingGalleryImages = (activeIndex) => {
    if (visibleMediaItems.length < 2) return;

    let imagesQueued = 0;
    let offset = 1;
    while (imagesQueued < galleryPreloadAhead && offset < visibleMediaItems.length) {
      const preloadIndex = (activeIndex + offset) % visibleMediaItems.length;
      const mediaItem = visibleMediaItems[preloadIndex];
      const image = mediaItem?.querySelector('img');
      offset += 1;

      // Keep videos deferred; loading an iframe here would cost much more than preloading a photo.
      if (!image || mediaItem.querySelector('deferred-media')) continue;

      image.loading = 'eager';
      image.fetchPriority = 'low';
      image.dataset.ffsGalleryPreloaded = 'true';
      image.decode?.().catch(() => {});
      imagesQueued += 1;
    }
  };

  thumbnailButtons.forEach((thumbnail, index) => {
    const deferredMedia = visibleMediaItems[index]?.querySelector('deferred-media');

    thumbnail.addEventListener('click', () => {
      requestAnimationFrame(() => {
        preloadUpcomingGalleryImages(index);
        if (deferredMedia && !deferredMedia.hasAttribute('loaded')) {
          deferredMedia.querySelector('.deferred-media__poster')?.click();
        }
      });
    });
  });

  const initialGalleryIndex = Math.max(
    thumbnailButtons.findIndex((thumbnail) => thumbnail.getAttribute('aria-current') === 'true'),
    0,
  );
  const initialGalleryImage = visibleMediaItems[initialGalleryIndex]?.querySelector('img');
  if (initialGalleryImage?.complete && initialGalleryImage.naturalWidth > 0) {
    preloadUpcomingGalleryImages(initialGalleryIndex);
  } else {
    initialGalleryImage?.addEventListener('load', () => preloadUpcomingGalleryImages(initialGalleryIndex), { once: true });
  }

  if (galleryViewer && thumbnailButtons.length > 1 && !galleryViewer.querySelector('.ffs-main-kit-gallery-button')) {
    const moveGallery = (direction) => {
      const currentIndex = thumbnailButtons.findIndex((thumbnail) => thumbnail.getAttribute('aria-current') === 'true');
      const nextIndex = (Math.max(currentIndex, 0) + direction + thumbnailButtons.length) % thumbnailButtons.length;
      thumbnailButtons[nextIndex].click();
    };

    const addGalleryButton = (direction, label, modifier) => {
      const control = document.createElement('button');
      control.type = 'button';
      control.className = `ffs-main-kit-gallery-button ffs-main-kit-gallery-button--${modifier}`;
      control.setAttribute('aria-label', label);
      control.innerHTML = modifier === 'previous'
        ? '<svg aria-hidden="true" viewBox="0 0 24 24" focusable="false"><path d="M15 5 8 12l7 7" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        : '<svg aria-hidden="true" viewBox="0 0 24 24" focusable="false"><path d="m9 5 7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      control.addEventListener('click', () => moveGallery(direction));
      galleryViewer.appendChild(control);
    };

    addGalleryButton(-1, 'Previous product photo', 'previous');
    addGalleryButton(1, 'Next product photo', 'next');
  }

  const cartLink = document.querySelector('.header__icon--cart');
  if (cartLink) {
    cartLink.dataset.ffsTooltip = 'View Shopping Cart';
    cartLink.setAttribute('aria-label', 'View Shopping Cart');
    cartLink.setAttribute('title', 'View Shopping Cart');
  }

  const accountLink = document.querySelector('.header__icon--account');
  if (accountLink) {
    const accountLabel = accountLink.querySelector('.visually-hidden')?.textContent.trim() || 'Account';
    accountLink.dataset.ffsTooltip = accountLabel;
    accountLink.setAttribute('title', accountLabel);
  }

  const reviewLightbox = document.querySelector('[data-ffs-review-lightbox]');
  const reviewLightboxImage = reviewLightbox?.querySelector('[data-ffs-review-lightbox-image]');
  const reviewLightboxCaption = reviewLightbox?.querySelector('[data-ffs-review-lightbox-caption]');
  const reviewLightboxPrevious = reviewLightbox?.querySelector('[data-ffs-review-lightbox-previous]');
  const reviewLightboxNext = reviewLightbox?.querySelector('[data-ffs-review-lightbox-next]');
  const reviewLightboxClose = reviewLightbox?.querySelector('[data-ffs-review-lightbox-close]');
  const reviewLightboxImageButton = reviewLightbox?.querySelector('[data-ffs-review-lightbox-image-button]');
  let reviewPhotoButtons = [];
  let reviewPhotoIndex = 0;
  let reviewLightboxScrollY = 0;

  const lockReviewLightboxPage = () => {
    reviewLightboxScrollY = window.scrollY;
    document.body.style.top = `-${reviewLightboxScrollY}px`;
    document.body.classList.add('ffs-lightbox-open');
  };

  const unlockReviewLightboxPage = () => {
    if (!document.body.classList.contains('ffs-lightbox-open')) return;
    document.body.classList.remove('ffs-lightbox-open');
    document.body.style.removeProperty('top');
    window.scrollTo(0, reviewLightboxScrollY);
  };

  const closeReviewLightbox = () => {
    if (!reviewLightbox) return;
    if (reviewLightbox.open) reviewLightbox.close();
    else unlockReviewLightboxPage();
  };

  const updateReviewLightbox = () => {
    const photoButton = reviewPhotoButtons[reviewPhotoIndex];
    const sourceImage = photoButton?.querySelector('img');
    if (!sourceImage || !reviewLightboxImage || !reviewLightboxCaption) return;

    reviewLightboxImage.src = sourceImage.dataset.ffsFullSrc || sourceImage.currentSrc || sourceImage.src;
    reviewLightboxImage.alt = sourceImage.alt;
    reviewLightboxCaption.textContent = `${sourceImage.alt} · Photo ${reviewPhotoIndex + 1} of ${reviewPhotoButtons.length}`;
  };

  const moveReviewLightbox = (direction) => {
    if (!reviewPhotoButtons.length) return;
    reviewPhotoIndex = (reviewPhotoIndex + direction + reviewPhotoButtons.length) % reviewPhotoButtons.length;
    updateReviewLightbox();
  };

  const getReviewPhotoKey = (photoButton) => {
    const sourceImage = photoButton?.querySelector('img');
    if (sourceImage?.dataset.ffsPhotoKey) return sourceImage.dataset.ffsPhotoKey;
    const source = sourceImage?.dataset.ffsFullSrc || sourceImage?.currentSrc || sourceImage?.src || '';
    return source.split('?')[0].split('/').pop();
  };

  document.querySelectorAll('[data-ffs-review-photo]').forEach((photoButton) => {
    photoButton.addEventListener('click', () => {
      const gallery = photoButton.closest('.ffs-main-kit-review-gallery');
      if (gallery) {
        reviewPhotoButtons = [...gallery.querySelectorAll('[data-ffs-review-photo]')];
        reviewPhotoIndex = Math.max(reviewPhotoButtons.indexOf(photoButton), 0);
      } else {
        reviewPhotoButtons = [...document.querySelectorAll('.ffs-main-kit-review-gallery [data-ffs-review-photo]')];
        const selectedKey = getReviewPhotoKey(photoButton);
        reviewPhotoIndex = Math.max(reviewPhotoButtons.findIndex((button) => getReviewPhotoKey(button) === selectedKey), 0);
      }
      updateReviewLightbox();
      lockReviewLightboxPage();
      reviewLightbox?.showModal();
    });
  });

  reviewLightboxPrevious?.addEventListener('click', () => moveReviewLightbox(-1));
  reviewLightboxNext?.addEventListener('click', () => moveReviewLightbox(1));
  reviewLightboxClose?.addEventListener('click', closeReviewLightbox);
  reviewLightboxImageButton?.addEventListener('click', closeReviewLightbox);
  reviewLightbox?.addEventListener('click', (event) => {
    if (event.target === reviewLightbox) closeReviewLightbox();
  });
  reviewLightbox?.addEventListener('close', unlockReviewLightboxPage);
  reviewLightbox?.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeReviewLightbox();
  });
  reviewLightbox?.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      moveReviewLightbox(-1);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      moveReviewLightbox(1);
    }
  });

  let hovering = false;
  let focused = false;
  let clickBoost = false;
  let currentRpm = 0;
  let targetRpm = 0;
  let angle = 0;
  let previousFrame = null;
  let frameRequest = null;

  const moveToward = (value, target, amount) => value < target
    ? Math.min(value + amount, target)
    : Math.max(value - amount, target);

  const draw = () => {
    leftRotor.setAttribute('transform', `rotate(${angle.toFixed(3)})`);
    rightRotor.setAttribute('transform', `rotate(${-angle.toFixed(3)})`);
  };

  const updateTarget = () => {
    const loading = button.classList.contains('loading');
    const active = loading || clickBoost || hovering || focused;
    button.classList.toggle('ffs-main-kit-rotors-active', active);
    targetRpm = loading || clickBoost ? 110 : (hovering || focused ? 50 : 0);
    if (frameRequest === null && targetRpm > 0) frameRequest = requestAnimationFrame(tick);
  };

  const tick = (timestamp) => {
    if (previousFrame === null) previousFrame = timestamp;
    const elapsed = Math.min((timestamp - previousFrame) / 1000, 0.05);
    previousFrame = timestamp;
    const acceleration = targetRpm > currentRpm ? (targetRpm === 50 ? 100 : 220) : 100;
    currentRpm = moveToward(currentRpm, targetRpm, acceleration * elapsed);
    angle = (angle + currentRpm * 6 * elapsed) % 360;
    draw();

    if (currentRpm > 0.01 || targetRpm > 0) {
      frameRequest = requestAnimationFrame(tick);
    } else {
      currentRpm = 0;
      previousFrame = null;
      frameRequest = null;
    }
  };

  button.addEventListener('pointerenter', () => { hovering = true; updateTarget(); });
  button.addEventListener('pointerleave', () => { hovering = false; updateTarget(); });
  button.addEventListener('focus', () => { focused = true; updateTarget(); });
  button.addEventListener('blur', () => { focused = false; updateTarget(); });
  button.addEventListener('pointerdown', () => {
    clickBoost = true;
    updateTarget();
    window.setTimeout(() => {
      clickBoost = false;
      updateTarget();
    }, 900);
  });

  const loadingObserver = new MutationObserver(updateTarget);
  loadingObserver.observe(button, { attributes: true, attributeFilter: ['class'] });
  draw();
})();
